<script>
import {AxiosHelper} from '@src/utils/utils';
import Datatable from '@components/Datatable';

export default {
	components: { Datatable },
	props : {
	},
  data() {
    return {
			index : 0,
			orgFile : '',

			tableData : [],
			fileName : '',
			keyword : '',

			tableOption : {
				scrollY: 400,
				paging : false,
				searching: false,
				lengthChange: false,
				select: {
					style: 'multi'
				},
				columns : [
					{data : 'media', width: 40 },
					{data : 'norae_no', width : 50},
					{data : 'title', width : 250 },
					{data : 'artist', width : 150 },
					{data : 'regdate', width : 60 },
					{data : 'song_path', width : 130 },
				],
				columnDefs : [
					{
						render : (data, type, row) => {
							return `
								<div class="ellipsis" style="width:150px">
									<a title="${data}" style="">${data}</a>
								</div>`;
						},
						targets : 3
					},

				]
			},

    }
	},
	created() {
	},
	mounted() {
	},
	methods : {
		show() {
			this.getFile();

			this.$refs.modal.show();
		},

		getFile() {
			AxiosHelper.get(`/api/music/tmp/${this.index}`).then(ret => {
				this.fileName = ret.data.orgFile;
				this.keyword = ret.data.file;
				this.tableData = ret.data.list;

				this.index = ret.data.index.toInt();
				this.orgFile = ret.data.orgFile;
			});
		},

		save() {
			const selected = this.tableData.filter(v => {
				return v._selected;
			});

			const datas = {
				list : selected,
				orgFile : this.orgFile
			};
			
			this.pushMessage('저장 시작');
			AxiosHelper.post(`/api/music/tmp/save`, {
				datas : JSON.stringify(datas)
			}).then(ret => {
				this.pushMessage('저장 완료');
				this.getFile();
			})
		},

		nextFile() {
			this.index++;
			this.getFile();
		},

		remove() {
			if(!window.confirm('정말로 삭제할까요?')) {
				return;
			}

			AxiosHelper.get('/api/music/tmp/delete', {
				params : {
					delFile : this.orgFile
				}
			}).then(ret => {
				this.getFile();
			});
		},

		fileRename() {
			if(this.fileName === '') {
				window.alert('변경할 파일이름 입력 필요');
				return;
			}

			AxiosHelper.post(`/api/music/tmp/rename`, {
				orgname : this.orgFile,
				rename : this.fileName,
			}).then(ret => {
				this.pushMessage(ret.msg);
				this.getFile();
			});
		},
		
		tableClick(index, data, event) {
			this.tableData = this.tableData.map(v => {
				if(v.media === data.media && v.norae_no === data.norae_no)
					return { ...v, _selected : !v._selected };
				return v;
			});
		},


	}
}
</script>

<template>
	<C.Modal ref="modal" title='파일 매치'
		dialog-class-name="modal-dialog-scrollable modal-lg"
	>
		<C.Row>
			<C.Col lg="12">
				<div class="button-list">
					<button type="button" class="btn btn-info waves-effect waves-light" @click="save">저장</button>
					<button type="button" class="btn btn-info waves-effect waves-light" @click="nextFile">다음파일</button>
					<button type="button" class="btn btn-danger waves-effect waves-light" @click="remove">삭제</button>
				</div>
			</C.Col>
		</C.Row>
		<C.Row>
			<C.Col lg="12">
				<div class="form-row align-items-center">
					<div class="col-lg-6">
						<input v-model="fileName" type="text" class="form-control form-control-sm"/>
					</div>
					<div class="col-auto">
						<button type="button" class="btn btn-blue btn-sm	 waves-effect waves-light" @click="fileRename">변경</button>
					</div>
					<div class="col-lg-4">
						<input :value="'검색어 : ' + keyword" type="text" readOnly class="form-control-plaintext form-control-sm" />
					</div>
				</div>
			</C.Col>
		</C.Row>

		<Datatable
			:data="tableData"
			:option="tableOption"
			table-add-classes='table-xs'
			table-remove-classes='table-sm'
			click-selctor="td"
			@clickHandler="tableClick"
		>
			<template v-slot:thead>
				<tr>
					<th>종류</th>
					<th>곡번호</th>
					<th>제목</th>
					<th>가수</th>
					<th>등록일</th>
					<th>파일유무</th>
				</tr>
			</template>
		</Datatable>
	</C.Modal>
</template>